export const FREQUENCY_TYPES = {
  None: 0,
  Secondly: 1,
  Minutely: 2,
  Hourly: 3,
  Daily: 4,
  Weekly: 5,
  Monthly: 6,
  Yearly: 7,
};

export const FREQUENCIES = [
  { value: FREQUENCY_TYPES.Hourly, name: 'Hourly' },
  { value: FREQUENCY_TYPES.Daily, name: 'Daily' },
  { value: FREQUENCY_TYPES.Weekly, name: 'Weekly' },
  { value: FREQUENCY_TYPES.Monthly, name: 'Monthly' },
  { value: FREQUENCY_TYPES.Yearly, name: 'Yearly' },
];

export const WEEKDAYS_CHOICES = [
  { value: 0, dayOfWeek: 0, title: 'Sunday', label: 'Sun' },
  { value: 1, dayOfWeek: 1, title: 'Monday', label: 'Mon' },
  { value: 2, dayOfWeek: 2, title: 'Tuesday', label: 'Tue' },
  { value: 3, dayOfWeek: 3, title: 'Wednesday', label: 'Wed' },
  { value: 4, dayOfWeek: 4, title: 'Thursday', label: 'Thu' },
  { value: 5, dayOfWeek: 5, title: 'Friday', label: 'Fri' },
  { value: 6, dayOfWeek: 6, title: 'Saturday', label: 'Sat' },
];

export const FREQUENCY_OCCURRENCES = {
  None: 0,
  Last: -1,
  SecondToLast: -2,
  ThirdToLast: -3,
  FourthToLast: -4,
  FifthToLast: -5,
  First: 1,
  Second: 2,
  Third: 3,
  Fourth: 4,
  Fifth: 5,
};

export const POSITIONS = [
  // { value: FREQUENCY_OCCURRENCES.None, title: 'None' },

  { value: FREQUENCY_OCCURRENCES.First, title: 'First' },
  { value: FREQUENCY_OCCURRENCES.Second, title: 'Second' },
  { value: FREQUENCY_OCCURRENCES.Third, title: 'Third' },
  { value: FREQUENCY_OCCURRENCES.Fourth, title: 'Fourth' },

  { value: FREQUENCY_OCCURRENCES.Last, title: 'Last' },
  { value: FREQUENCY_OCCURRENCES.SecondToLast, title: 'Second to last' },
  { value: FREQUENCY_OCCURRENCES.ThirdToLast, title: 'Third to last' },
  { value: FREQUENCY_OCCURRENCES.FourthToLast, title: 'Fourth to last' },
  { value: FREQUENCY_OCCURRENCES.FifthToLast, title: 'Fifth to last' },
];

export const MONTHS = [
  { value: 1, title: 'January', label: 'Jan' },
  { value: 2, title: 'February', label: 'Feb' },
  { value: 3, title: 'March', label: 'Mar' },

  { value: 4, title: 'April', label: 'Apr' },
  { value: 5, title: 'May', label: 'May' },
  { value: 6, title: 'June', label: 'Jun' },

  { value: 7, title: 'July', label: 'Jul' },
  { value: 8, title: 'August', label: 'Aug' },
  { value: 9, title: 'September', label: 'Sep' },

  { value: 10, title: 'October', label: 'Oct' },
  { value: 11, title: 'November', label: 'Nov' },
  { value: 12, title: 'December', label: 'Dec' },
];

export const INPUT_TYPES = {
  INPUT_NUMBER: 0,
  SELECT: 1,
  MULTI_SELECT: 2,
  CHECKBOX: 3,
};

export const GROUP_TYPES = {
  NONE: 0,
  RADIO: 1,
  CHECKBOX: 2,
};

export const RECURRENCE_ENDS = {
  NEVER: 0,
  ON: 1,
  AFTER: 2,
};

export const CONFIRM_ACTION_TYPES = {
  NONE: 0,
  EDIT: 1,
  DELETE: 2,
};

export const EDIT_EVENT_TYPES = {
  NONE: 0,
  THIS: 1,
  THIS_AND_FOLLOWING: 2,
  ALL: 3,
};

export const EDIT_EVENT_TYPE_OPTIONS = [
  { value: EDIT_EVENT_TYPES.THIS, title: 'This event' },
  { value: EDIT_EVENT_TYPES.THIS_AND_FOLLOWING, title: 'This and following events' },
  { value: EDIT_EVENT_TYPES.ALL, title: 'All events' },
];
